import styled from 'styled-components'

const Placeholder = styled.div<{ $width: number; $height: number }>`
  padding-bottom: ${({ $width, $height }) => ($height * 100) / $width}%;
  width: 100%;
`

export default Placeholder
